__turbopack_context__.v({
  "actionButton": "CookieConsentBanner-module__b7XtRG__actionButton",
  "actions": "CookieConsentBanner-module__b7XtRG__actions",
  "closeButton": "CookieConsentBanner-module__b7XtRG__closeButton",
  "content": "CookieConsentBanner-module__b7XtRG__content",
  "description": "CookieConsentBanner-module__b7XtRG__description",
  "heading": "CookieConsentBanner-module__b7XtRG__heading",
  "policyLink": "CookieConsentBanner-module__b7XtRG__policyLink",
  "primary": "CookieConsentBanner-module__b7XtRG__primary",
  "root": "CookieConsentBanner-module__b7XtRG__root",
});
